import axios from 'axios';

export const get3PDeliverablesDetails = (storeGuid, optionId) => {
  return axios.get(`/deliveryoptions/${storeGuid}/quotes/${optionId}`).then((response) => response.data);
};
